import React from 'react'
import { Crown, TestTube, Play } from 'lucide-react'
import { getAdminBadgeProps } from '@/utils/adminUtils'

const AdminBadge = ({ currentUserData, className = '', size = 'sm' }) => {
  const badgeProps = getAdminBadgeProps(currentUserData)
  
  if (!badgeProps) {
    return null
  }

  const { label, bgColor, textColor, borderColor } = badgeProps

  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-1 text-sm',
    md: 'px-3 py-1.5 text-base',
    lg: 'px-4 py-2 text-lg'
  }

  const iconSize = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18
  }

  const getIcon = () => {
    switch (label) {
      case 'Admin':
        return <Crown size={iconSize[size]} />
      case 'Test User':
        return <TestTube size={iconSize[size]} />
      case 'Demo User':
        return <Play size={iconSize[size]} />
      default:
        return null
    }
  }

  return (
    <div 
      className={`
        inline-flex items-center gap-1.5 rounded-full border
        ${bgColor} ${textColor} ${borderColor} ${sizeClasses[size]}
        font-medium
        ${className}
      `}
      title={`${label} privileges active`}
    >
      {getIcon()}
      <span>{label}</span>
    </div>
  )
}

export default AdminBadge 